module.exports = __webpack_public_path__ + "img/icon_history_selected.778fd5d4.svg";